import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../stack/integrations/components/IntegrationImage";

const TOTAL_ROW_ID = "total_id";

const getDiffText = (diff) => {
  return (
    <Typography variant="caption">
      {diff > 0
        ? `(↑${diff})`
        : diff < 0
        ? `(↓${Math.abs(diff)})`
        : diff === 0
        ? "( - )"
        : ""}
    </Typography>
  );
};

const getCellContent = (params, diff) => {
  if (!params.value || params.value === 0) return "-";

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={0.5}>
      <Typography variant="body2">{params.value} </Typography>
      {getDiffText(diff)}
    </Box>
  );
};

export const getColumns = () => {
  return [
    {
      field: "source",
      headerName: "Source",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      disableReorder: true,
      renderCell: (params) => (
        <IntegrationImage
          name={params.row.source === TOTAL_ROW_ID ? "" : params.value}
          width={"22px"}
          newLogo={true}
        />
      ),
    },
    {
      field: "host",
      headerName: "Hosts",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      renderCell: (params) => {
        const diff = params.row.hostDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "user",
      headerName: "Users",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      renderCell: (params) => {
        const diff = params.row.userDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "server",
      headerName: "Servers",
      headerAlign: "center",
      align: "center",
      minWidth: 110,
      renderCell: (params) => {
        const diff = params.row.serverDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "data_store",
      headerName: "Datastores",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      renderCell: (params) => {
        const diff = params.row.data_storeDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "app",
      headerName: "Apps",
      headerAlign: "center",
      align: "center",
      minWidth: 90,
      renderCell: (params) => {
        const diff = params.row.appDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "nonhuman_identity",
      headerName: "NHIs",
      headerAlign: "center",
      align: "center",
      minWidth: 90,
      renderCell: (params) => {
        const diff = params.row.nonhuman_identityDiff;
        return getCellContent(params, diff);
      },
    },
    {
      field: "total",
      headerName: "Total",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      disableReorder: true,
      renderCell: (params) => {
        const diff = params.row.totalDiff;
        return getCellContent(params, diff);
      },
    },
  ];
};
